/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input,
} from '@angular/core';
import { focusNewItem } from '../../shared/focus-new-item';

// /projects/t/:tags in the 2026 design. The AngularJS page looped over `projects.featured`, which FeedStore
// never sets, so it was always empty; this one lists feedItems. ProjectListCtrl still sends an empty first page to 404.
@Component({
  selector: 'ut-project-list-page',
  templateUrl: './project-list-page.component.html',
  styleUrls: ['./project-list-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProjectListPageComponent {
  // The `projectlist` state's resolves: the loaded FeedStore and the raw `tags` param ("a+b").
  @Input({ required: true }) projects: any;
  @Input({ required: true }) tags: string;

  constructor(
    private cdr: ChangeDetectorRef,
    private el: ElementRef<HTMLElement>,
  ) {}

  get tagList(): string[] {
    return this.tags.split('+');
  }

  get status(): string {
    if (this.projects.isLoading) return 'Loading projects';
    const count = this.projects.feedItems.length;
    return count === 1 ? '1 project shown' : `${count} projects shown`;
  }

  loadMore(): void {
    const next = this.projects.feedItems.length;
    this.cdr.markForCheck();
    this.projects.loadMore().then(() => {
      this.cdr.markForCheck();
      const item = this.projects.feedItems[next];
      if (item) focusNewItem(this.el.nativeElement, `#project_${item.id} > article`);
    });
  }
}
